/* Gallery + lightbox, single-option size picker, discount/scarcity display
   and AJAX add-to-cart for editorial-product.liquid. */
(function () {
  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'PKR', currencyDisplay: 'narrowSymbol' });
  }

  // Same "round to the nearest 5" as the server-rendered discount badge.
  function roundOff(percent) {
    return Math.round(percent / 5) * 5;
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-editorial-root][data-ed-product-title]');
    var variantsEl = document.querySelector('[data-ed-product-variants]');
    if (!root || !variantsEl) return;

    var productTitle = root.getAttribute('data-ed-product-title') || '';
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }

    var form = root.querySelector('#ed-product-form');
    var variantInput = root.querySelector('[data-ed-variant-id]');
    var priceEl = root.querySelector('[data-ed-price]');
    var comparePriceEl = root.querySelector('[data-ed-compare-price]');
    var discountEl = root.querySelector('[data-ed-discount]');
    var scarcityEl = root.querySelector('[data-ed-scarcity]');
    var lowStockThreshold = scarcityEl ? parseInt(scarcityEl.getAttribute('data-ed-low-stock-threshold'), 10) || 0 : 0;
    var addBtn = root.querySelector('[data-ed-add-to-cart]');
    var buyBtn = root.querySelector('[data-ed-buy-now]');
    var toast = root.querySelector('[data-ed-added-toast]');
    var toastTimer = null;
    // One entry per option (1-indexed, matching Shopify's option1/2/3),
    // seeded from whichever button already renders .is-selected server-side
    // (the current/first-available variant) so the initial match below
    // (before any click) reflects that starting selection instead of only
    // being correct once every option has been explicitly clicked once.
    var selectedOptions = {};
    root.querySelectorAll('[data-ed-size-value].is-selected').forEach(function (btn) {
      selectedOptions[btn.getAttribute('data-ed-option-index')] = btn.getAttribute('data-ed-size-value');
    });

    /* ---- Lightbox (image gallery + size chart) ---- */
    var lightbox = document.querySelector('[data-ed-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-ed-lightbox-img]') : null;
    var lightboxPrev = lightbox ? lightbox.querySelector('[data-ed-lightbox-prev]') : null;
    var lightboxNext = lightbox ? lightbox.querySelector('[data-ed-lightbox-next]') : null;
    var lightboxClose = lightbox ? lightbox.querySelector('[data-ed-lightbox-close]') : null;
    var lightboxImages = [];
    var lightboxIndex = 0;

    function renderLightbox() {
      if (!lightboxImg) return;
      var item = lightboxImages[lightboxIndex];
      if (!item) return;
      lightboxImg.src = item.src;
      lightboxImg.alt = item.alt || '';
      var multi = lightboxImages.length > 1;
      if (lightboxPrev) lightboxPrev.hidden = !multi;
      if (lightboxNext) lightboxNext.hidden = !multi;
    }

    function openLightbox(images, startIndex) {
      if (!lightbox || !images || !images.length) return;
      lightboxImages = images;
      lightboxIndex = startIndex || 0;
      renderLightbox();
      lightbox.hidden = false;
      document.documentElement.setAttribute('data-ed-modal-open', 'true');
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.removeAttribute('data-ed-modal-open');
    }

    function lightboxStep(delta) {
      if (!lightboxImages.length) return;
      lightboxIndex = (lightboxIndex + delta + lightboxImages.length) % lightboxImages.length;
      renderLightbox();
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxStep(-1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxStep(1); });
    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }
    window.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxStep(-1);
      if (e.key === 'ArrowRight') lightboxStep(1);
    });

    /* ---- Gallery (thumbnails + main image) ---- */
    var mainImg = root.querySelector('[data-ed-active-img]');
    var galleryEl = document.querySelector('[data-ed-gallery-images]');
    var galleryImages = [];
    try { galleryImages = JSON.parse(galleryEl.textContent); } catch (e) { galleryImages = []; }
    var activeGalleryIndex = 0;

    var mainBtn = root.querySelector('[data-ed-open-gallery]');
    if (mainBtn) {
      mainBtn.addEventListener('click', function () {
        openLightbox(galleryImages, activeGalleryIndex);
      });
    }

    root.querySelectorAll('[data-ed-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) mainImg.src = thumb.getAttribute('data-ed-thumb');
        root.querySelectorAll('[data-ed-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        activeGalleryIndex = parseInt(thumb.getAttribute('data-ed-gallery-index'), 10) || 0;
      });
    });

    /* ---- Size chart popup ---- */
    var sizeChartBtn = root.querySelector('[data-ed-open-sizechart]');
    if (sizeChartBtn) {
      sizeChartBtn.addEventListener('click', function () {
        openLightbox([{ src: sizeChartBtn.getAttribute('data-ed-sizechart-src'), alt: sizeChartBtn.getAttribute('data-ed-sizechart-alt') }], 0);
      });
    }

    /* Size / option picker(s) — one group per product option (Size, Sleeve
       Style, ...); a variant only matches once every group's selection is
       satisfied, same as Shopify's own variant-picker logic.
       priorityIdx is the option group that was just clicked — if the exact
       combination of all current selections was never sold (e.g. this size
       was never offered in the previously-picked sleeve style), fall back
       to the first variant that still honors that one just-clicked value,
       same as Shopify's own picker snapping the other selectors instead of
       going blank. Without this, a stale non-match silently left the whole
       panel (price, stock, add-to-cart) frozen on whatever variant was
       last successfully matched. */
    function findMatchingVariant(priorityIdx) {
      var exact = variants.filter(function (v) {
        for (var idx in selectedOptions) {
          if (v['option' + idx] !== selectedOptions[idx]) return false;
        }
        return true;
      })[0];
      if (exact) return exact;
      if (priorityIdx && selectedOptions[priorityIdx]) {
        var fallback = variants.filter(function (v) { return v['option' + priorityIdx] === selectedOptions[priorityIdx]; })[0];
        if (fallback) return fallback;
      }
      return variants.filter(function (v) { return v.available; })[0] || variants[0];
    }

    // Keeps every option group's .is-selected in sync with whichever variant
    // actually ends up applied (including the fallback case above), so the
    // buttons never show a combination that isn't the one really on screen.
    function syncOptionButtons(match) {
      for (var i = 1; i <= 3; i++) {
        var value = match['option' + i];
        if (value === null || value === undefined) continue;
        selectedOptions[i] = value;
        root.querySelectorAll('[data-ed-size-value][data-ed-option-index="' + i + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b.getAttribute('data-ed-size-value') === value);
        });
      }
    }

    function applyVariant(match) {
      if (!match) return;
      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      var hasDiscount = match.compare_at_price && match.compare_at_price > match.price;
      if (comparePriceEl) {
        if (hasDiscount) {
          comparePriceEl.textContent = money(match.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      if (discountEl) {
        if (hasDiscount) {
          var rawOff = ((match.compare_at_price - match.price) / match.compare_at_price) * 100;
          discountEl.textContent = '−' + roundOff(rawOff) + '%';
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
      if (scarcityEl) {
        var low = match.inventory_management === 'shopify' && match.inventory_quantity > 0 && match.inventory_quantity <= lowStockThreshold;
        if (low) {
          scarcityEl.textContent = 'Only ' + match.inventory_quantity + ' piece' + (match.inventory_quantity !== 1 ? 's' : '') + ' left';
          scarcityEl.hidden = false;
        } else {
          scarcityEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      if (buyBtn) buyBtn.disabled = !match.available;
    }

    root.querySelectorAll('[data-ed-size-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-ed-option-index');
        selectedOptions[idx] = btn.getAttribute('data-ed-size-value');
        var match = findMatchingVariant(idx);
        syncOptionButtons(match);
        applyVariant(match);
      });
    });

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 3200);
    }

    function addVariantToCart(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
        return r.json();
      });
    }

    function addToCart() {
      if (!form || !variantInput) return Promise.reject(new Error('missing form'));
      return addVariantToCart(variantInput.value);
    }

    /* Quick add / buy on the "You might also like" cards */
    root.querySelectorAll('[data-ed-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-ed-quick-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        addVariantToCart(variantId)
          .then(function () {
            showToast('Added to cart.');
            updateCartCount();
          })
          .catch(function (err) { showToast(err.message || 'Could not add to cart.'); })
          .finally(function () { btn.disabled = false; });
      });
    });
    root.querySelectorAll('[data-ed-quick-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.getAttribute('data-ed-quick-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        addVariantToCart(variantId)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            showToast(err.message || 'Could not check out.');
            btn.disabled = false;
          });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        addToCart()
          .then(function () {
            var optionValues = [];
            for (var i = 1; i <= 3; i++) { if (selectedOptions[i]) optionValues.push(selectedOptions[i]); }
            var label = optionValues.length ? productTitle + ', ' + optionValues.join(' / ') : productTitle;
            showToast('Added — ' + label + '.');
            updateCartCount();
          })
          .catch(function (err) {
            showToast(err.message || 'Could not add to cart.');
          })
          .finally(function () {
            if (addBtn) addBtn.disabled = false;
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        buyBtn.disabled = true;
        addToCart()
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            showToast(err.message || 'Could not check out.');
            buyBtn.disabled = false;
          });
      });
    }
  });
})();
